import { type IProductSpecIterator, type IProductSpecItem } from "../..";
import { type VueProductSpecItem } from "./VueProductSpecItem";

export class VueProductSpecIterator implements IProductSpecIterator {
    static registrations: VueProductSpecItem[] = [];

    *getItems(): Generator<IProductSpecItem, any, any> {
        for (const registration of VueProductSpecIterator.registrations) {
            yield registration;
        }
    }
}
